import HARDCODE from '../../business-const/HardCode/HardCode'

import tipoRecursoFinanceiroList from './tipoRecursoFinanceiroList'



const tipoRecursoFinanceiroEntradaDadosList = ( idFamiliar, tipoRecursoFinanceiro ) => {
    
    let tipoRecursoFinanceiroEntradaDadosListAux = []

    tipoRecursoFinanceiroList.forEach( (linhaTipoRecursoFinanceiroList, index) => {
        if (
                linhaTipoRecursoFinanceiroList.permiteEntradaDados === "S" &&
                (
                    idFamiliar !== HARDCODE.idFamiliarCasal ||
                    linhaTipoRecursoFinanceiroList.id !==
                        HARDCODE.idTipoRecursoFinanceiroFgtsContribuicao
                ) && (
                    linhaTipoRecursoFinanceiroList.id === tipoRecursoFinanceiro ||
                    linhaTipoRecursoFinanceiroList.ativo !== 'N'
                )
        ) {

            tipoRecursoFinanceiroEntradaDadosListAux.push(
                linhaTipoRecursoFinanceiroList
            )
        }
    })

    return tipoRecursoFinanceiroEntradaDadosListAux
}

export default tipoRecursoFinanceiroEntradaDadosList